"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateParameters = exports.convertBulkExactMatchDataToSpins = void 0;
/**
 * Helper method to validate required parameters
 * @param {Array} validations - Array of validation objects
 * @param {*} validations[].param - The parameter value to validate
 * @param {string} validations[].name - The parameter name for the error message
 * @param {Function} [validations[].validationFn] - Optional custom validation function that returns true if valid
 * @throws {Error} If any parameter fails validation
 */
const validateParameters = (validations = []) => {
  const throwError = name => {
    throw new Error(`${name} is a required parameter.`);
  };
  for (const {
    param,
    name,
    validationFn
  } of validations) {
    if (validationFn ? !validationFn(param) : param == null) {
      throwError(name);
    }
    if (typeof param === 'string' && param === '' || Array.isArray(param) && param.length === 0 || typeof param === 'number' && isNaN(param)) {
      throwError(name);
    }
  }
};
exports.validateParameters = validateParameters;
const convertBulkExactMatchDataToSpins = (bulkExactMatchData = {}) => {
  return {
    ...bulkExactMatchData,
    RecommendedDomains: [...(bulkExactMatchData.ExactMatchDomains || [])]
  };
};
exports.convertBulkExactMatchDataToSpins = convertBulkExactMatchDataToSpins;